import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const CardCorteTec = ({ data }) => {
    const [ttls, setTttls] = useState({
        totaltk: '0',
        totalins: '0',
        total: '0',
    });
    useEffect(() => {
        setTttls(data.totales[0]);
    }, [data]);
    return (
        <Row>
            <Col xs={12}>
                <Card className="widget-inline">
                    <Card.Body className="p-0">
                        <Row className="g-0">
                            <Col sm={4} lg={4}>
                                <Card className="shadow-none m-0">
                                    <Card.Body className="text-center">
                                        <h3>
                                            <span>${ttls.totaltk}</span>
                                        </h3>
                                        <p className="text-muted font-15 mb-0">Total De tickets</p>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={4} lg={4}>
                                <Card className="shadow-none m-0 border-start">
                                    <Card.Body className="text-center">
                                        <h3>
                                            <span>${ttls.totalins}</span>
                                        </h3>
                                        <p className="text-muted font-15 mb-0">Total instalaciones </p>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={4} lg={4}>
                                <Card className="shadow-none m-0 border-start">
                                    <Card.Body className="text-center">
                                        <h3>
                                            <span>${ttls.total}</span>
                                        </h3>
                                        <p className="text-muted font-15 mb-0">Total</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default CardCorteTec;
